export default "__VITE_ASSET__CTdCDssu__"